import { Box, SxProps, TableCell, TableRow } from '@mui/material';
import { FunctionComponent } from 'react';
import { Loader } from '../../../../ui/components';
import { ChartSettings } from '../../../chart-settings/model';
import { useNetworkServiceBitratesApiGet } from '../../hooks';
import { ThroughputMonitoredServiceApiModel } from '../../model';
import {BitrateStatisticsTableChart} from "../BitrateStatisticsTableChart/BitrateStatisticsTableChart";

const EXPAND_ROW_ACTION_ICON_COLUMNS_COUNT = 1;

interface Props {
  monitoredService: ThroughputMonitoredServiceApiModel;
  chartSettings: ChartSettings;
  columnsQuantity: number;
  customerId: number | null;
}

export const BitrateStatisticsTableRow: FunctionComponent<Props> = ({
  monitoredService,
  columnsQuantity,
  chartSettings,
  customerId
}) => {
  const { networkServiceBitrateStatistics, isFetched, isFetching }
    = useNetworkServiceBitratesApiGet(customerId, monitoredService.itemId, monitoredService.throughput, chartSettings, 'table');
  const containerSx: SxProps = { display: 'flex', justifyContent: 'center', alignItems: 'center', columnGap: '4rem' };
  const chartSx: SxProps = { width: '33%' };

  return <TableRow style={{ background: '#EFF6FF' }} className={'MuiTableRowExpanded'}>
    <TableCell colSpan={ EXPAND_ROW_ACTION_ICON_COLUMNS_COUNT + columnsQuantity }>
      { isFetching && <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Loader loading={true} />
      </Box> }
      { !isFetching && isFetched && <Box sx={containerSx} data-testid={'charts'}>
        { networkServiceBitrateStatistics && <>
          <Box sx={ chartSx }>
            <BitrateStatisticsTableChart
              monitoredService={ monitoredService }
              chartData={ networkServiceBitrateStatistics }
              metrics={ ["txBitRate", "rxBitRate"] }
              unit='bps'
              chartSettings={ chartSettings }
              customerId={ customerId }
            />
          </Box>
          <Box sx={ chartSx }>
            <BitrateStatisticsTableChart
              monitoredService={ monitoredService }
              chartData={ networkServiceBitrateStatistics }
              metrics={ ["outgoingTraffic", "incomingTraffic"] }
              unit='%'
              chartSettings={ chartSettings }
              customerId={ customerId }
            />
          </Box>
        </>}
      </Box> }
    </TableCell>
  </TableRow>;
};